<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="benefitForm">
                    <!--Forms-->
                    <div class="forms-container">
                        <div class="row no-margin">
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationId">State :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="locationId"
                                              multiple
                                              name="locationId"
                                              id="locationId"
                                              label="text"
                                              @change="changedValue"
                                              @input="changedValueLocation()"
                                              :filterable="false"
                                              :options="locationArr"
                                              @search="onSearchLocation"
                                              placeholder="Select State">
                                        <template slot="no-options">
                                            Search State...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{locationError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationType">Location Type :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="locationType"
                                              name="locationType"
                                              id="locationType"
                                              label="text"
                                              :clearable="false"
                                              :searchable="false"
                                              :filterable="false"
                                              :options="locationTypeArr"
                                              placeholder="Select Location Type">
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="mediaCaption">Banner :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-dropzone
                                        id="drop1"
                                        :options="bannerDropzoneOptions"
                                        ref="bannerDropzone"
                                        :destroyDropzone="false"
                                        :headers="bannerDropzoneOptions.headers"
                                        @vdropzone-removed-file="removeSelectedBanner"
                                        @vdropzone-success="bannerFileSuccess"
                                        @vdropzone-duplicate-file="duplicateBanner"
                                        @vdropzone-total-upload-progress="progressOfUloadBanner"
                                        name="file"
                                        >
                                    </vue-dropzone>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{bannerCropError}}</font>
                                </div>
                            </div>
                            <!--Description-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="description">Description :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <tinymce :plugins="['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality','template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample']" id="description" v-model="description" class= "" ref="tm" ></tinymce>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{descriptionError}}</font>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="contactno">Toll Free Number :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="contactno" type="text" class="form-control" id="title" placeholder="Toll Free Number" maxlength="190">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{contactnoError}}</font>
                                </div>
                            </div>
                            <!-- Flyer Inputs -->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="flyer_label">Flyer Label :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="flyer_label" type="text" class="form-control" id="title" placeholder="Flyer Label" maxlength="190">
                                    <div v-if="isFlyerUploaded" class="requiredstar">*</div>
                                    <font class="text-danger">{{flyer_labelError}}</font>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="drop2">Flyer :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-dropzone
                                        id="drop2"
                                        :options="flyerDropzoneOptions"
                                        ref="flyerDropzone"
                                        :destroyDropzone="false"
                                        :headers="flyerDropzoneOptions.headers"
                                        @vdropzone-removed-file="removeSelectedFlyer"
                                        @vdropzone-success="flyerFileSuccess"
                                        @vdropzone-duplicate-file="duplicateFlyer"
                                        @vdropzone-total-upload-progress="progressOfUloadFlyer"
                                        name="file1"
                                        >
                                    </vue-dropzone>
                                    <font class="text-danger">{{flyerCropError}}</font>
                                </div>
                            </div>
                            <!-- Flyer Inputs -->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="pamphlet_label">Pamphlet Label :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="pamphlet_label" type="text" class="form-control" id="title" placeholder="Pamphlet Label" maxlength="190">
                                    <div v-if="isPamphletUploaded" class="requiredstar">*</div>
                                    <font class="text-danger">{{pamphlet_labelError}}</font>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="drop3">Pamphlet :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-dropzone
                                        id="drop3"
                                        :options="pamphletDropzoneOptions"
                                        ref="pamphletDropzone"
                                        :destroyDropzone="false"
                                        :headers="pamphletDropzoneOptions.headers"
                                        @vdropzone-removed-file="removeSelectedPamphlet"
                                        @vdropzone-success="pamphletFileSuccess"
                                        @vdropzone-duplicate-file="duplicatePamphlet"
                                        @vdropzone-total-upload-progress="progressOfUloadPamphlet"
                                        name="file2"
                                        >
                                    </vue-dropzone>
                                    <font class="text-danger">{{pamphletCropError}}</font>
                                </div>
                            </div>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addBenifitBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addBenefit()">
                                    <input id="addAndContinueBenifitBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addBenefit(flag='Save and Continue')">
                                    <input id="CancelBenifit" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    import tinymce from 'vue-tinymce-editor';

    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';

    export default {
        name: 'AddBenefits',
        components: {
            vueDropzone: vue2Dropzone,
            'v-select': vSelect,
            'tinymce': tinymce,
            'app-backend-footer': BackendFooter,
        },
        mixins: [SessioMixin],
        data() {
            return {
                updateId: 0,
                bannerDropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 150, //MB
                    maxFiles: 1, //ToDo : to decide number of files allowed
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    acceptedFiles: ".jpg, .jpeg, .png",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 1 file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },
                bannerCropError: '',
                bannerType: '',
                bannerSize: 0,
                bannerPath: '',
                isBannerUploaded: false,
                flyerDropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/store_document",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 150, //MB
                    maxFiles: 1, //ToDo : to decide number of files allowed
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    //acceptedFiles: ".jpg, .jpeg, .png",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 1 file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },
                flyerCropError: '',
                flyerType: '',
                flyerSize: 0,
                flyerPath: '',
                isFlyerUploaded: false,
                flyer_label: '',
                flyer_labelError: '',
                pamphletDropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/store_document",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 150, //MB
                    maxFiles: 1, //ToDo : to decide number of files allowed
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    //acceptedFiles: ".jpg, .jpeg, .png",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 1 file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },
                pamphletCropError: '',
                pamphletType: '',
                pamphletSize: 0,
                pamphletPath: '',
                isPamphletUploaded: false,
                pamphlet_label: '',
                pamphlet_labelError: '',
                description: '',
                descriptionError: '',
                contactno: '',
                contactnoError: '',
                locationType: {value: 'other', text: 'Other'},
                locationTypeArr: [
                    {value: 'other', text: 'Other'},
                    {value: 'Velocity SBA', text: 'Velocity SBA'}
                ],
                pageTitle: '',
                locationId: '',
                locationArr: [],
                locationError: '',
                fileUploaded: true,
                fileUploadedFlyer: true,
                fileUploadedPamphlet: true,
            }
        },

        watch: {
            description: function (description) {
                if (description.length > 0) {
                    self.descriptionError = "";
                }
            },
            flyerPath:function(flyerPath){
                self.isFlyerUploaded = true;
                if(flyerPath == ''){
                    self.isFlyerUploaded = false;
                    self.flyer_labelError = '';
                }
            },
            pamphletPath:function(pamphletPath){
                self.isPamphletUploaded = true;
                if(pamphletPath == ''){
                    self.isPamphletUploaded = false;
                    self.pamphlet_labelError = '';
                }
            },
        },

        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.showLoader();
            var path = window.location.pathname;
            var segments = path.split("/");
            self.loadLocationsAdd();
            self.pageTitle = 'Add Benefit Support';
            if (segments[2] == 'updatebenefitsupport') {
                if (segments[3]) {
                    self.updateId = segments[3];
                    self.pageTitle = 'Edit Benefit Support';
                    self.loadBenefitSupport();
                    $("#addAndContinueBenifitBtn").hide();
                    $("#addBenifitBtn").val("Update");
                    $("#benefitHeader").text("Edit Benefit");
                }
            }
            $("#alertError").hide();
            $("#locationId").on('change', function () {
                self.locationError = '';
            });
            $("#contactno").on('keyup', function () {
                self.contactnoError = '';
            });
            $("#flyer_label").on('keyup', function () {
                self.flyer_labelError = '';
            });
            $("#pamphlet_label").change(function () {
                self.pamphlet_labelError = '';
            });
        },
        methods: {
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/listbenefitsupports');
            },
            removeAllBannerFiles() {
                self.$refs.bannerDropzone.removeAllFiles();
            },
            removeSelectedBanner(file, xhr, error) {
                var removeFile = "";
                if ("manuallyAdded" in file == true) {
                    if (self.bannerPath == file.name) {
                        removeFile = self.bannerPath;
                    }
                } else {
                    var filePath = JSON.parse(file.xhr.response);
                    removeFile = filePath.content.media_path;

                    self.removeFileFromServer(removeFile);
                }
                self.bannerPath = '';
                self.bannerType = '';
                self.bannerSize = 0;
                if (self.bannerPath == '') {
                    self.isBannerUploaded = false;
                }
            },
            bannerFileSuccess: function (file, response) {
                self.isBannerUploaded = true;
                self.bannerPath = response.content.media_path;
                self.bannerType = file.type;
                self.bannerSize = file.size;
                if (self.bannerPath != '') {
                    self.bannerCropError = "";
                } else {
                    self.bannerCropError = 'Please Upload Banner';
                }
            },
            duplicateBanner: function (file) { // Todo: Understand functionality. Not Working till date.
                /*console.log("Duplicate file" + file.name);*/
            },
            removeAllFlyerFiles() {
                self.$refs.flyerDropzone.removeAllFiles();
            },
            removeSelectedFlyer(file, xhr, error) {
                /*console.log(file);*/
                var removeFile = "";
                if ("manuallyAdded" in file == true) {
                    if (self.flyerPath == file.name) {
                        removeFile = self.flyerPath;
                    }
                } else {
                    var filePath = JSON.parse(file.xhr.response);
                    removeFile = filePath.content;
                    self.removeFileFromServer(removeFile);
                }
                self.flyerPath = '';
                self.flyerType = '';
                self.flyerSize = 0;
                if (self.flyerPath != '') {
                    self.isFlyerUploaded = false;
                }
            },
            flyerFileSuccess: function (file, response) {
                self.isFlyerUploaded = true;
                self.flyerPath = response.content;
                self.flyerType = file.type;
                self.flyerSize = file.size;
                if (self.flyerPath != '') {
                    self.flyerCropError = "";
                } else {
                    self.flyerCropError = 'Please Upload Flyer';
                }
            },
            duplicateFlyer: function (file) { // Todo: Understand functionality. Not Working till date.
                /*console.log("Duplicate file" + file.name);*/
            },
            removeAllPamphletFiles() {
                self.$refs.pamphletDropzone.removeAllFiles();
            },
            removeSelectedPamphlet(file, xhr, error) {
                var removeFile = "";
                if ("manuallyAdded" in file == true) {
                    if (self.pamphletPath == file.name) {
                        removeFile = self.pamphletPath;
                    }
                } else {
                    var filePath = JSON.parse(file.xhr.response);
                    removeFile = filePath.content;
                    self.removeFileFromServer(removeFile);
                }
                self.pamphletPath = '';
                self.pamphletType = '';
                self.pamphletSize = 0;
                if (self.pamphletPath == '') {
                    self.isPamphletUploaded = false;
                }
            },
            pamphletFileSuccess: function (file, response) {
                self.isPamphletUploaded = true;
                self.pamphletPath = response.content;
                self.pamphletType = file.type;
                self.pamphletSize = file.size;
                if (self.pamphletPath != '') {
                    self.pamphletCropError = "";
                } else {
                    self.pamphletCropError = 'Please Upload Flyer';
                }
            },
            duplicatePamphlet: function (file) { // Todo: Understand functionality. Not Working till date.
                /*console.log("Duplicate file" + file.name);*/
            },
            vfilesAdded: function (file) {
                /*console.log("vfilesAdded Called");*/
                /*console.log(file);*/
                for (var i = 0; i < file.length; i++) {
                    var indiFile = file[i];
                    var fileSize = indiFile.size / (1024 * 1024);
                    /*console.log(fileSize);*/
                    //return;
                    if (indiFile.type == 'image/jpeg' || indiFile.type == 'image/jpg' || indiFile.type == 'image/png') {
                        if (fileSize > 0.1) { // Allowing image upto 4 MB to be uploaded
                            alert("Please select media upto 4 MB of size.");
                            self.$refs.bannerDropzone.removeFile(indiFile);
                        }
                    }
                }
            },
            removeFileFromServer: function (filePath) {
                filePath = (filePath === null || typeof (filePath) === "undefined" || filePath == '') ? '' : filePath;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            changedValue: function (value) {

            },

            changedValueLocation: function () {
                self.locationError = "";
            },

            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocationsAdd(loading, search, this);
                }
            },

            checkForm: function () {
                var checked = true;
                self.locationError = self.bannerCropError = self.descriptionError = self.contactnoError = "";

                if (self.locationId.length === 0) {
                    self.locationError = "State Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.isBannerUploaded) {
                    self.bannerCropError = 'Please Upload Banner';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.fileUploaded == false) {
                    self.bannerCropError = "Please Wait While Banner Is Being Uploaded";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.description.length <= 0) {
                    self.descriptionError = 'Please Write Some Description';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.contactno == "") {
                    self.contactnoError = "Toll Free Number Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.contactno && !String(self.contactno).match(/^[0-9]*$/)) {
                    self.contactnoError = "Toll Free Number Must Be Numeric";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.contactno && String(self.contactno).match(/^[0-9]*$/) && self.contactno.length < 8) {
                    self.contactnoError = "Phone Number Must Be Of Minimum 8 Digits";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.contactno && String(self.contactno).match(/^[0-9]*$/) && self.contactno.length > 15) {
                    self.contactnoError = "Phone Number Must Be Of Maximum 15 Digits";
                    if (checked) {
                        checked = false;
                    }
                }

                if (self.isFlyerUploaded) {
                    if (self.flyer_label == "") {
                        self.flyer_labelError = 'Please Add Flyer Label';
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (self.fileUploadedFlyer == false) {
                    self.flyerCropError = "Please Wait While Flyer Is Being Uploaded";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.fileUploadedPamphlet == false) {
                    self.pamphletCropError = "Please Wait While Pamphlet Is Being Uploaded";
                    if (checked) {
                        checked = false;
                    }
                }

                if (self.isPamphletUploaded) {
                    if (self.pamphlet_label == "") {
                        self.pamphlet_labelError = 'Please Add Pamphlet Label';
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                return checked;
            },

            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            self.locationArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            addBenefit(flag) {
                self.checkForm();
                if (self.checkForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var locationsId = '';
                    for (var i = 0; i < self.locationId.length; i++) {
                        locationsId += (self.locationId[i].value) + ',';
                    }
                    locationsId = locationsId.replace(/,\s*$/, "");
                    var data = {};
                    data.location_id = locationsId;
                    data.location_type = self.locationType.value;
                    data.banner_type = self.bannerType;
                    data.banner_size = self.bannerSize;
                    data.banner_path = self.bannerPath;
                    data.description = self.description;
                    data.tall_free_no = self.contactno;
                    data.flyer_label = self.flyer_label;
                    data.flyer_type = self.flyerType;
                    data.flyer_size = self.flyerSize;
                    data.flyer_path = self.flyerPath;
                    data.pamphlet_label = self.pamphlet_label;
                    data.pamphlet_type = self.pamphletType;
                    data.pamphlet_size = self.pamphletSize;
                    data.pamphlet_path = self.pamphletPath;
                    /*console.log(JSON.stringify(data));
                     return false;*/
                    if (segments[2] == 'updatebenefitsupport') {
                        if (segments[3]) {
                            data.id = self.updateId;
                            $("#addBenifitBtn").val("Updating ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueBenifitBtn").val("Saving ...");
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            } else {
                                $("#addBenifitBtn").val("Saving ...");
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            }
                        }
                    } else {
                        if (flag == "Save and Continue") {
                            $("#addAndContinueBenifitBtn").val("Saving ...");
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            $("#addBenifitBtn").val("Saving ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        }
                    }
                    self.showLoader();
                    HTTP.post("addeditbenefitsupport", data, config)
                            .then(function (response) {
                                self.removeAllBannerFiles();
                                self.removeAllFlyerFiles();
                                self.removeAllPamphletFiles();
//                        console.log(response.data.content);
                                if (segments[2] == 'updatebenefitsupport') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    }
                                }

                                if (response.data.message == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");

                                    if (flag == "Save and Continue") {
//                                $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        self.locationId = '';
                                        self.locationType = '';
                                        self.bannerType = '';
                                        self.bannerSize = 0;
                                        self.bannerPath = '';
                                        self.description = '';
                                        self.contactno = '';
                                        self.flyer_label = '';
                                        self.flyerType = '';
                                        self.flyerSize = 0;
                                        self.flyerPath = '';
                                        self.pamphlet_label = '';
                                        self.pamphletType = '';
                                        self.pamphletSize = 0;
                                        self.pamphletPath = '';
                                        self.locationArr = [];
                                        self.loadLocationsAdd();
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.removeAllBannerFiles();
                                self.removeAllFlyerFiles();
                                self.removeAllPamphletFiles();
                                if (segments[2] == 'updatebenefitsupport') {
                                    if (segments[3]) {
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            self.locationId = '';
                                            self.locationType = '';
                                            self.bannerType = '';
                                            self.bannerSize = 0;
                                            self.bannerPath = '';
                                            self.description = '';
                                            self.contactno = '';
                                            self.flyer_label = '';
                                            self.flyerType = '';
                                            self.flyerSize = 0;
                                            self.flyerPath = '';
                                            self.pamphlet_label = '';
                                            self.pamphletType = '';
                                            self.pamphletSize = 0;
                                            self.pamphletPath = '';
                                            self.locationArr = [];
                                            self.loadLocationsAdd();
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        self.locationId = '';
                                        self.locationType = '';
                                        self.bannerType = '';
                                        self.bannerSize = 0;
                                        self.bannerPath = '';
                                        self.description = '';
                                        self.contactno = '';
                                        self.flyer_label = '';
                                        self.flyerType = '';
                                        self.flyerSize = 0;
                                        self.flyerPath = '';
                                        self.pamphlet_label = '';
                                        self.pamphletType = '';
                                        self.pamphletSize = 0;
                                        self.pamphletPath = '';
                                        self.locationArr = [];
                                        self.loadLocationsAdd();
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show")
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            });
                }
            },

            loadBenefitSupport: function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        id: segments[3],
                    }
                };
                self.showLoader();
                HTTP.get("getbennefitsupports", config)
                        .then(function (response) {
                            self.locationId = [];
                            for (var i = 0; i < response.data.content[0].location.length; i++) {
                                self.locationId.push({'text': response.data.content[0].location[i].name, 'value': response.data.content[0].location[i].id});
                            }
                            self.locationType = {'text': self.formatString(response.data.content[0].location_type), 'value': response.data.content[0].location_type};
                            self.description = response.data.content[0].description;
                            self.contactno = response.data.content[0].tallfree_no;
                            self.flyer_label = response.data.content[0].flyer_label;
                            self.pamphlet_label = response.data.content[0].pamphlet_label;
                            self.bannerType = response.data.content[0].banner_type;
                            self.bannerSize = response.data.content[0].banner_size;
                            if (response.data.content[0].banner_url != '') {
                                self.bannerPath = self.uploadManually(response.data.content[0].banner_url, self.bannerType, self.bannerSize, 'bannerDropzone');
                            }
                            self.flyerType = response.data.content[0].flyer_type;
                            self.flyerSize = response.data.content[0].flyer_size;
                            if (response.data.content[0].flyer_url != '') {
                                self.flyerPath = self.uploadManually(response.data.content[0].flyer_url, self.flyerType, self.flyerSize, 'flyerDropzone');
                            }
                            self.pamphletType = response.data.content[0].pamphlet_type;
                            self.pamphletSize = response.data.content[0].pamphlet_size;
                            if (response.data.content[0].pamphlet_url != '') {
                                self.pamphletPath = self.uploadManually(response.data.content[0].pamphlet_url, self.pamphletType, self.pamphletSize, 'pamphletDropzone');
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                value = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return value;
            },
            uploadManually: function (url, type, size, reference) {

                var self = this;

                var url = url;
                var file_name = self.getFileName(url);
                var file_path = file_name.file_path;
                var file_name = file_name.file_name;
                var file_type = type;
                var file_size = size;
                var file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                switch (reference) {
                    case 'bannerDropzone':
                        self.$refs.bannerDropzone.manuallyAddFile(file_data, url);
                        self.isBannerUploaded = true;
                        break;
                    case 'flyerDropzone':
                        self.$refs.flyerDropzone.manuallyAddFile(file_data, url);
                        self.isFlyerUploaded = true;
                        break;
                    default:
                        self.$refs.pamphletDropzone.manuallyAddFile(file_data, url);
                        self.isPamphletUploaded = true;
                }
                return file_path;
            },
            getFileName: function (file) {

                var self = this;
                var src = file.split('/');
                var file_name = src[src.length - 1];
                var orgPath = src[src.length - 2]

                var arr = {};
                arr.file_name = file_name;
                arr.file_path = String(orgPath + "/" + file_name);
                return arr;
            },
            progressOfUloadBanner(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.fileUploaded = true;
                    self.bannerCropError = "";
                } else {
                    self.fileUploaded = false;
                }
            },
            progressOfUloadFlyer(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.fileUploadedFlyer = true;
                    self.flyerCropError = "";
                } else {
                    self.fileUploadedFlyer = false;
                }
            },
            progressOfUloadPamphlet(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.fileUploadedPamphlet = true;
                    self.pamphletCropError = "";
                } else {
                    self.fileUploadedPamphlet = false;
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/benefits/AddBenefitSupports.vue